import React from 'react'

import BasicRoute from 'components/routes/BasicRoute'

import ImplementoConsulta from 'entity/Implemento/components/ImplementoConsulta'
import ImplementoForm from 'entity/Implemento/components/ImplementoForm'

export default function index() {
    return (
        <>
            <BasicRoute
                perfilAuth={['r9jrEQXznNgjrZTGCfch', 'RECT03jkyTQW9B2OMz47']}//admin ou tecnico
                uid="consulta-implemento"
                route="consulta-implemento"

                menuProps={{
                    text: "Implementos",
                    sequence: "111117",
                    iconName: "DeviceHub",

                    parent: {
                        uid: "parentCadastros",
                        text: "Cadastros",
                        sequence: "222222",
                        iconName: 'Edit'
                    }
                }}

                element={<ImplementoConsulta />}
            />
            <BasicRoute
                uid="implemento"
                route="_implemento"
                element={<ImplementoForm />}
            />
        </>
    )
}
